import {SessionStore} from '@store/session.store';
import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';

export const qrOnlyGuard: CanActivateFn = (route, state) => {
  const sessionStore = inject(SessionStore); // Cambiar
  const router = inject(Router);
  if (sessionStore.tableUID()) { // Cambiar
    return true;
  }
  return router.createUrlTree(['/splash']);
};
